import { render, staticRenderFns } from "./MuokkaaKumppani.vue?vue&type=template&id=7b4fa40c&"
import script from "./MuokkaaKumppani.vue?vue&type=script&lang=js&"
export * from "./MuokkaaKumppani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports